import React from 'react';
import { User } from 'lucide-react';

const UserProfile = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center mb-4">
          <User className="w-6 h-6 text-primary mr-2" />
          <h1 className="text-3xl font-bold text-gray-900">User Profile</h1>
        </div>
        <p className="text-gray-600">User Profile page content will be added here.</p>
      </div>
    </div>
  );
};

export default UserProfile;

